import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c3a17bd&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/styles/list.scss?vue&type=style&index=0&id=6c3a17bd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a17bd",
  null
  
)

export default component.exports